import { Group } from "@mantine/core"
import { Button, ActionIcon } from "@tfg/ui"
import { useContext } from "react"

import { FindOperationChainsResponseDto } from "~/gen/api"
import { useDeleteOpChainMutation } from "~/pages/Admin/Ingestion/OpChains/hooks/useDeleteOpChainMutation"
import { OpChainContext } from "~/pages/Admin/Ingestion/OpChains/store/op-chain-context"

type Props = {
  operationChain: FindOperationChainsResponseDto
}

export function OperationChainListItem({ operationChain }: Props) {
  const { openOpChainManagementContainer } = useContext(OpChainContext)
  const { mutate: deleteOpChain } = useDeleteOpChainMutation()

  function handleClick() {
    openOpChainManagementContainer(operationChain.id)
  }

  return (
    <Group>
      <Button miw={160} onClick={handleClick}>
        {operationChain.name}{" "}
      </Button>
      <ActionIcon
        type="delete"
        onClick={() => deleteOpChain(operationChain.id)}
      />
    </Group>
  )
}
